import React from 'react';
import cn from 'classnames';
import { getTranslations } from '@translations';
import { Button, Hr } from '@components';
import { useHeaderContext } from '../../../../../../HeaderContext';

import styles from './styles/index.module.scss';

const Login = () => {
  const { platformBaseUrl } = useHeaderContext();
  const translations = getTranslations();
  const url = translations('header.account.login.url');
  const inscriptionUrl = translations(
    'header.subheader.account.login.menu.url',
  );

  return (
    <>
      <div className={styles.userMenuItem}>
        <Button
          color="primary"
          tag="a"
          type="block"
          href={`${platformBaseUrl}${url}`}
          /**
           * This classname helps in making the bridge between manomano-sf to open
           * the modal to login
           */
          className={cn(styles.loginButton, 'js-user-authentication-modal')}
        >
          {translations('header.subheader.account.login.button')}
        </Button>

        <p className={styles.loginParagraph}>
          {translations('header.subheader.account.login.paragraph')}
          <a
            className={styles.userMenuLink}
            href={`${platformBaseUrl}${inscriptionUrl}`}
          >
            {translations('header.subheader.account.login.menu.link')}
          </a>
        </p>
      </div>
      <Hr />
    </>
  );
};
export default Login;
